import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';
import { UploadService } from './Upload.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class IvrgatewayService extends ApiEvsService {
  constructor(
    http: Http,
    router: Router,
    private uploadService: UploadService
  ) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/v2/ivrgateways', query);
  }

  create(body: any) {
    return this.post('/v2/ivrgateway', body);
  }

  find(id) {
    return this.get('/v2/ivrgateway/' + id);
  }

  update(id, body) {
    return this.put('/v2/ivrgateway/' + id, body);
  }

  allIvrgateway(query?: any) {
    return this.get('/v2/all-ivrgateway', query);
  }

  _delete(id) {
    return this.delete('/v2/ivrgateway/' + id);
  }

  listAudios(query?: any) {
    return this.get('/v2/ivr/audio', query);
  }
  createAudio(body: any, file: any) {
    return this.uploadService.postWithFile(environment.api_evs + '/v2/ivr/audio', file, body);
  }
  deleteAudios(body: any) {
    return this.post('/v2/ivr/delete-audio', body);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Ivrgateway.service.ts